<template>
  <div class="footer">
    <div class="container">
      <div class="image-container">
        <h1 class="pt-5">{{$t ("main_title")}}</h1>
      </div>

      <div class="content-box">
        <h3>{{ $t("Ijtimoiy tarmoqlarimiz") }}</h3>
        <div class="social-icons">
          <div>
            <a
              href="https://instagram.com"
              target="_blank"
              class="social-icon"
              aria-label="Instagram"
            >
              <i class="fab fa-instagram"></i>
            </a>
          </div>
          <div>
            <a
              href="https://t.me/House_Museum_Yunus_Rajabiy"
              target="_blank"
              class="social-icon"
              aria-label="Telegram"
            >
              <i class="fab fa-telegram-plane"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="bot-sect">© 2025 Yunus Rajabiy Muzey, Inc.</div>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<style scoped>
.footer {
  width: 100%;
  /* margin-top: 100px; */
  background: #1E1E19;
  color: #EBE9CF;
  text-align: center;
}

.main {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0 auto;
}

.image-container {
  /* margin-top: 40px; */
  flex: 1;
  text-align: center;
  padding-right: 20px;
}

.image-container img {
  width: 160px;
  height: auto;
}

.image-container p {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.5;
  color: #EBE9CF;
}

.content-box {
  color: #224de7;
  padding: 20px;
  border-radius: 10px;
  flex: 1;
  transition: all 0.3s ease;
  min-width: 200px;
}

.content-box h3 {
  color: #EBE9CF;
  font-size: 18px;
  padding: 5px 0;
}

.footer_text {
  color: #EBE9CF;
  font-size: 14px;
}

.links {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.link {
  color: #EBE9CF;
  font-size: 14px;
  text-decoration: none;
}

.link:hover {
  color: #EBE9CF;
  text-decoration: underline;
}

.social-icons {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 10px;
}

.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  filter: grayscale(100%);
  border-radius: 50%;
  border: 1px solid #EBE9CF;
  font-size: 16px;
  color: #EBE9CF;
  transition: 0.3s;
}

.social-icon:hover,
.social-icon:focus {
  border: 1px solid #EBE9CF;
  color: #EBE9CF;
}

.social-icon i {
  font-size: 16px;
}

.bot-sect {
  padding: 12px 0;
  color: #EBE9CF;
  font-size: 12px;
}

@media (max-width: 480px) {
  .footer {
    padding: 20px 10px;
  }

  .main {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 20px;
  }

  .image-container {
    margin-top: 20px;
    flex: 0 0 100%;
    padding-right: 0;
  }

  .content-box {
    flex: 1;
    text-align: center;
    padding: 15px;
    width: 100%;
    margin: 10px 0;
  }

  .content-box h3 {
    padding: 10px 0;
    font-size: 18px;
  }

  .links {
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: center;
  }

  .link {
    font-size: 14px;
  }

  .social-icons {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 20px;
  }

  .social-icon i {
    font-size: 25px;
  }

  .bot-sect {
    font-size: 12px;
    margin-top: 20px;
  }
}
</style>
